module.exports = __webpack_public_path__ + "img/combo2.ac28cffc.webp";